/* eslint-disable react-hooks/exhaustive-deps */
import { Box, DialogActions, DialogContent, Button, TextField, Autocomplete } from '@mui/material'
import ComboBox from 'Components/ComboBox'
import { CustomAutoComplete } from 'Components/CustomAutoComplete'
import { CustomTextField } from 'Components/CustomTextField'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { TYPE_DE_BIEN } from 'utils/constants'
import { UTILISATION } from 'utils/constants'
import { makeGetRequest, makePostRequest } from 'utils/api'
export const GeneralInformationForm = ({
  formErrors,
  setStep,
  setUtilisationType,
  setFinalPayload,
  handleClose,
  activeDocument,
  energyClassification,
  typeDeBien,
  superficie,
  setFiles,
  getPays,
  typeDeChauffage,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    clearErrors,
    setError,
    control,
  } = useForm({
    defaultValues: {
      nom: '',
      pays: '',
      utilisation: '',
      pieces: '',
      superficie: '',
      // consumption: '',
      // emission_CO2: '',
      energy_classification: '',
      type_de_bien: '',
      picture: '',
    },
  })

  const [picerror, setPicerror] = useState(false)

  useEffect(() => {
    if (Object.keys(activeDocument).length > 0) {
      reset({ ...activeDocument })
    } else {
      setFiles(null)
      reset({
        nom: '',
        pays: '',
        utilisation: '',
        pieces: '',
        superficie: '',
        // consumption: '',
        // emission_CO2: '',
        energy_classification: '',
        type_de_bien: '',
        picture: '',
      })
    }
    // fetchPays()
  }, [activeDocument])

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }
    delete payload.picture

    setUtilisationType(data.utilisation)
    setFinalPayload({ ...payload })
    setStep(1)
  }
  return (
    // <Box component="form" onSubmit={handleSubmit(onSubmit)}>
    <Box sx={{ maxWidth: 300 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <CustomTextField
            required
            label="Nom"
            fullWidth
            placeholder="Enter Nom"
            register={{
              ...register('nom', {
                required: { value: true, message: 'Nom is required' },
                maxLength: { value: 30, message: 'Nom cannot be more than 30 characters' },
              }),
            }}
            error={(errors.nom && true) || (formErrors.nom && true)}
            helperText={(errors.nom && errors.nom.message) || formErrors.nom}
          />
          <Controller
            name={'pays'}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <Autocomplete
                disablePortal
                disabled={getPays ? false : true}
                sx={{ marginTop: '7px' }}
                options={getPays}
                getOptionLabel={(option) =>
                  option?.label ?? getPays.find(({ id }) => id === option)?.label ?? ''
                }
                isOptionEqualToValue={(option, value) => option.value === value.value}
                {...field}
                renderInput={(params) => (
                  <TextField required {...params} size="small" label="Pays" />
                )}
                onChange={(_event, data) => field.onChange(data?.id || '')}
              />
            )}
          />
          {/* <CustomTextField
          required
          label="Pays"
          fullWidth
          placeholder="Enter Pays"
          register={{
            ...register('pays', {
              required: { value: true, message: 'Pays is required' },
              maxLength: { value: 2, message: 'Pays cannot be more then 2 characters' },
            }),
          }}
          error={(errors.pays && true) || (formErrors.pays && true)}
          helperText={errors.pays?.message || formErrors.pays}
        /> */}
          <CustomTextField
            label="Nombre de pièces"
            fullWidth
            placeholder="Enter Pieces"
            register={{
              ...register('pieces', {
                maxLength: { value: 5, message: 'Pieces cannot be more then 5 characters' },
              }),
            }}
            error={(errors.pieces && true) || (formErrors.pieces && true)}
            helperText={errors.pieces?.message || formErrors.pieces}
          />
          {/* <CustomTextField
          label="Superficie"
          type="number"
          fullWidth
          placeholder="Enter Superficie"
          register={{
            ...register('superficie', {
              maxLength: { value: 5, message: 'Superficie cannot be more then 5 characters' },
            }),
          }}
          error={(errors.superficie && true) || (formErrors.superficie && true)}
          helperText={errors.superficie?.message || formErrors.superficie}
        /> */}
          {/* <Controller
          name={'consumption'}
          control={control}
          // defaultValue={'Maison'}
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <Autocomplete
              disablePortal
              sx={{ marginTop: '7px' }}
              options={typeDeChauffage}
              getOptionLabel={(option) =>
                option?.label ?? typeDeChauffage.find(({ id }) => id === option)?.label ?? ''
              }
              isOptionEqualToValue={(option, value) => option.value === value.value}
              {...field}
              renderInput={(params) => (
                <TextField required {...params} size="small" label="Consommation énérgétique" />
              )}
              onChange={(_event, data) => field.onChange(data?.id || '')}
            />
          )}
        /> */}
          <Controller
            name={'superficie'}
            control={control}
            // defaultValue={'Maison'}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <Autocomplete
                disablePortal
                sx={{ marginTop: '7px' }}
                options={superficie}
                getOptionLabel={(option) =>
                  option?.label ?? superficie.find(({ id }) => id === option)?.label ?? ''
                }
                isOptionEqualToValue={(option, value) => option.value === value.value}
                {...field}
                renderInput={(params) => (
                  <TextField required {...params} size="small" label="Superficie" />
                )}
                onChange={(_event, data) => field.onChange(data?.id || '')}
              />
            )}
          />
          {/* <CustomTextField
          label="Consommation énérgétique"
          fullWidth
          type="number"
          placeholder="Enter Consommation énérgétique"
          register={{
            ...register('consumption', {
              maxLength: {
                value: 5,
                message: 'Consommation énérgétique cannot be more then 5 characters',
              },
            }),
          }}
          error={(errors.consumption && true) || (formErrors.consumption && true)}
          helperText={errors.consumption?.message || formErrors.consumption}
        />
        <CustomTextField
          label="Emission C02"
          type="number"
          fullWidth
          placeholder="Enter Emission CO2"
          register={{
            ...register('emission_CO2', {
              maxLength: {
                value: 5,
                message: 'Emission C02 cannot be more then 5 characters',
              },
            }),
          }}
          error={(errors.emission_CO2 && true) || (formErrors.emission_CO2 && true)}
          helperText={errors.emission_CO2?.message || formErrors.emission_CO2}
        /> */}
          {/* <CustomTextField
          label="Classe énérgétique"
          fullWidth
          placeholder="Ex. A"
          register={{
            ...register('energy_classification', {
              maxLength: {
                value: 1,
                message: 'Classe énérgétique cannot be more then 1 characters',
              },
              pattern: { value: /^[A-Z]*$/, message: 'Accept only upper case character' },
            }),
          }}
          error={
            (errors.energy_classification && true) || (formErrors.energy_classification && true)
          }
          helperText={errors.energy_classification?.message || formErrors.energy_classification}
        /> */}

          <Controller
            name={'energy_classification'}
            control={control}
            // defaultValue={'Maison'}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <Autocomplete
                disablePortal
                sx={{ marginTop: '7px' }}
                options={energyClassification}
                getOptionLabel={(option) =>
                  option?.label ?? energyClassification.find(({ id }) => id === option)?.label ?? ''
                }
                isOptionEqualToValue={(option, value) => option.value === value.value}
                {...field}
                renderInput={(params) => (
                  <TextField required {...params} size="small" label="Classe énérgétique" />
                )}
                onChange={(_event, data) => field.onChange(data?.id || '')}
              />
            )}
          />
          <Controller
            name={'type_de_bien'}
            control={control}
            // defaultValue={'Maison'}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <Autocomplete
                disablePortal
                sx={{ marginTop: '7px' }}
                options={typeDeBien}
                getOptionLabel={(option) =>
                  option?.label ?? typeDeBien.find(({ id }) => id === option)?.label ?? ''
                }
                isOptionEqualToValue={(option, value) => option.value === value.value}
                {...field}
                renderInput={(params) => (
                  <TextField required {...params} size="small" label="Type de bien" />
                )}
                onChange={(_event, data) => field.onChange(data?.id || '')}
              />
            )}
          />

          <Controller
            name={'utilisation'}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <Autocomplete
                disablePortal
                disabled={activeDocument.utilisation ? true : false}
                sx={{ marginTop: '7px' }}
                options={UTILISATION}
                getOptionLabel={(option) =>
                  option?.label ?? UTILISATION.find(({ label }) => label === option)?.label ?? ''
                }
                isOptionEqualToValue={(option, value) => option.lable === value.label}
                {...field}
                renderInput={(params) => (
                  <TextField required {...params} size="small" label="Utilisation" />
                )}
                onChange={(_event, data) => field.onChange(data?.label || '')}
              />
            )}
          />
          {activeDocument.utilisation ? (
            ''
          ) : (
            <CustomTextField
              label="Picture"
              type="file"
              fullWidth
              inputProps={{
                accept: 'image/*',
                multiple: true,
              }}
              multiple
              register={{
                ...register('picture', {
                  onChange: (e) => {
                    if (e.target.files.length > 5) {
                      setPicerror(true)
                      setError('picture', {
                        type: 'custom',
                        message: 'Picture cannot be more the 5.',
                      })
                    } else {
                      setFiles(e.target.files)
                      setPicerror(false)
                      clearErrors('picture')
                    }
                  },
                }),
              }}
              error={(errors.picture && true) || (formErrors.picture && true)}
              helperText={
                errors.picture?.message || formErrors.picture || 'Picture cannot be more the 5.'
              }
            />
          )}
          {/* <ComboBox
          handleAutoComplete={( e, j ) => setValue( 'Pays', j )}
          label="Pays"
          data={getPays}
          name="Pays"
        /> */}
        </DialogContent>
        <DialogActions>
          <Button type="submit" disabled={picerror ? picerror : false}>
            Valider
          </Button>
          <Button onClick={() => handleClose()}>Annuler</Button>
        </DialogActions>
        {/* </Box> */}
      </form>
    </Box>
  )
}
